import React, { useMemo, useState } from "react";
import DynamicTable from "../../../../utils/Table/DynamicTable";
import AdminAppChild from "./AdminAppChild/AdminAppChild";
import RenderActions from "../CommonComponent/RenderActions";
import { useSelector } from "react-redux";
import { showErrorToast } from "../../../../utils/Toast/toast";
import { patchAPI } from "../../../../API/ApiService";
import { BASE_URL } from "../../../../constant/apiUrl";
import Loading from "../../../../utils/Loader";
import { setApp } from "../../../../slices/appadminSlice";
import { useDispatch } from "react-redux";
import fetchAndCacheImage from "../../../../utils/fetchandCatchImages";
const columns = [
  { id: "actions", label: " ", width: "80px" },
  {
    id: "title",
    label: "TITLE",
    width: "200px",
  },
 
  { id: "link", label: "LINK", width: "200px" },
];
 
export default function AppTable({ searchText, mobileLoading }) {
  const [expandedRow, setExpandedRow] = useState(null);
  const { apps } = useSelector((store) => store.appadmin);
  const [loading, setLoading] = useState(false);
  const toggleRowExpansion = (rowId) => {
    setExpandedRow((prev) => (prev === rowId ? null : rowId));
  };
  const dispatch = useDispatch();
  const handleCancel = () => {
    setExpandedRow(null);
  };
  const renderActions = (row) => RenderActions(expandedRow);
 
  const renderChild = (row) => (
    <AdminAppChild
      data-testid="child-component"
      data={row}
      onCancel={handleCancel}
    />
  );
 
  const handleRowOrderChange = async (newRows) => {
    setLoading(true);
    try {
      const rowId = newRows.map((item) => item.id);
 
      const response = await patchAPI(
        `${BASE_URL}/admin/apps/update-order`,
        rowId
      );
 
      if (response?.status === 200) {
        const mergedData = await Promise.all(
          response?.data?.response?.map(async (item) => {
            const match = apps.find((app) => app.id === item.id);
 
            let url = match?.image;
 
            if (!url || url.trim() === "") {
              // If no image found, fetch from API
              try {
                url = await fetchAndCacheImage(item.emblemFileId);
              } catch (err) {
                console.error(
                  `Failed to fetch image for app ID ${item.id}`,
                  err
                );
              }
            }
 
            return {
              ...item,
              image: url,
            };
          })
        );
 
        dispatch(setApp(mergedData));
      }
    } catch (e) {
      showErrorToast("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <>
      {loading && <Loading />}
      <DynamicTable
        columns={columns}
        rows={apps}
        searchText={searchText}
        renderActions={(row) => renderActions(row)}
        onRowClick={(row) => {
          toggleRowExpansion(row.id);
        }}
        expandedRow={expandedRow}
        showColumnFilters={false}
        rowsPerPage={50}
        renderChildComponent={renderChild}
        onRowOrderChange={(newOrder) => {
          handleRowOrderChange(newOrder);
        }}
        enableDragAndDrop={true}
        pagination={false}
        loading={mobileLoading}
      />
    </>
  );
}
